var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteUserModalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 104,
    viewBox: "0 0 216 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 91H137C137.515 91 138.017 90.9444 138.5 90.8389C138.983 90.9444 139.485 91 140 91H192C195.866 91 199 87.866 199 84C199 80.134 195.866 77 192 77H186C182.134 77 179 73.866 179 70C179 66.134 182.134 63 186 63H205C208.866 63 212 59.866 212 56C212 52.134 208.866 49 205 49H183C186.866 49 190 45.866 190 42C190 38.134 186.866 35 183 35H119C122.866 35 126 31.866 126 28C126 24.134 122.866 21 119 21H62C58.134 21 55 24.134 55 28C55 31.866 58.134 35 62 35H22C18.134 35 15 38.134 15 42C15 45.866 18.134 49 22 49H47C50.866 49 54 52.134 54 56C54 59.866 50.866 63 47 63H7C3.13401 63 0 66.134 0 70C0 73.866 3.13401 77 7 77H46C42.134 77 39 80.134 39 84C39 87.866 42.134 91 46 91ZM209 91C212.866 91 216 87.866 216 84C216 80.134 212.866 77 209 77C205.134 77 202 80.134 202 84C202 87.866 205.134 91 209 91Z",
    fill: "#F4F9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141 7C142.657 7 144 5.65685 144 4C144 2.34315 142.657 1 141 1C139.343 1 138 2.34315 138 4C138 5.65685 139.343 7 141 7Z",
    fill: "#044D6E",
    stroke: "#044D6E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172 23C173.657 23 175 21.6569 175 20C175 18.3431 173.657 17 172 17C170.343 17 169 18.3431 169 20C169 21.6569 170.343 23 172 23Z",
    fill: "#044D6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.243 14.7573L148.885 23.1156L157.243 14.7573ZM148.758 14.7573L157.116 23.1156L148.758 14.7573Z",
    fill: "#044D6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.758 14.7573L157.116 23.1156M157.243 14.7573L148.885 23.1156L157.243 14.7573Z",
    stroke: "#044D6E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4043 32.5962L54.4043 38.5962L60.4043 32.5962ZM54.4043 32.5962L60.4043 38.5962L54.4043 32.5962Z",
    fill: "#044D6E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4043 32.5962L60.4043 38.5962M60.4043 32.5962L54.4043 38.5962L60.4043 32.5962Z",
    stroke: "#044D6E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68 26C69.6569 26 71 24.6569 71 23C71 21.3431 69.6569 20 68 20C66.3431 20 65 21.3431 65 23C65 24.6569 66.3431 26 68 26Z",
    fill: "#044D6E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.04 97.0048L84.1711 89.2358C87.7049 76.4764 97.0114 70.0293 106.318 70.0293",
    stroke: "#044D6E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.318 69.9755C113.767 69.9755 119.806 63.9368 119.806 56.4877C119.806 49.0387 113.767 43 106.318 43C98.8687 43 92.8301 49.0387 92.8301 56.4877C92.8301 63.9368 98.8687 69.9755 106.318 69.9755Z",
    stroke: "#044D6E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.488 101.975C126.937 101.975 132.975 95.9368 132.975 88.4877C132.975 81.0387 126.937 75 119.488 75C112.039 75 106 81.0387 106 88.4877C106 95.9368 112.039 101.975 119.488 101.975Z",
    stroke: "#044D6E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.144 82.8571H122.287V81.7143C122.287 81.2596 122.106 80.8236 121.785 80.5021C121.463 80.1806 121.027 80 120.572 80H117.144C116.689 80 116.253 80.1806 115.932 80.5021C115.61 80.8236 115.43 81.2596 115.43 81.7143V82.8571H112.572C112.421 82.8571 112.276 82.9173 112.168 83.0245C112.061 83.1317 112.001 83.277 112.001 83.4286C112.001 83.5801 112.061 83.7255 112.168 83.8326C112.276 83.9398 112.421 84 112.572 84H113.144V94.2857C113.144 94.7404 113.324 95.1764 113.646 95.4979C113.967 95.8194 114.403 96 114.858 96H122.858C123.313 96 123.749 95.8194 124.07 95.4979C124.392 95.1764 124.572 94.7404 124.572 94.2857V84H125.144C125.295 84 125.441 83.9398 125.548 83.8326C125.655 83.7255 125.715 83.5801 125.715 83.4286C125.715 83.277 125.655 83.1317 125.548 83.0245C125.441 82.9173 125.295 82.8571 125.144 82.8571ZM116.572 81.7143C116.572 81.5627 116.633 81.4174 116.74 81.3102C116.847 81.2031 116.992 81.1429 117.144 81.1429H120.572C120.724 81.1429 120.869 81.2031 120.976 81.3102C121.084 81.4174 121.144 81.5627 121.144 81.7143V82.8571H116.572V81.7143ZM123.43 94.2857C123.43 94.4373 123.369 94.5826 123.262 94.6898C123.155 94.7969 123.01 94.8571 122.858 94.8571H114.858C114.707 94.8571 114.561 94.7969 114.454 94.6898C114.347 94.5826 114.287 94.4373 114.287 94.2857V84H123.43V94.2857Z",
    fill: "#044D6E",
    stroke: "#044D6E",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.572 86.2861C120.421 86.2861 120.276 86.3463 120.168 86.4535C120.061 86.5607 120.001 86.706 120.001 86.8576V92.0004C120.001 92.152 120.061 92.2973 120.168 92.4045C120.276 92.5116 120.421 92.5718 120.572 92.5718C120.724 92.5718 120.869 92.5116 120.976 92.4045C121.084 92.2973 121.144 92.152 121.144 92.0004V86.8576C121.144 86.706 121.084 86.5607 120.976 86.4535C120.869 86.3463 120.724 86.2861 120.572 86.2861Z",
    fill: "#044D6E",
    stroke: "#044D6E",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.146 86.2861C116.994 86.2861 116.849 86.3463 116.742 86.4535C116.634 86.5607 116.574 86.706 116.574 86.8576V92.0004C116.574 92.152 116.634 92.2973 116.742 92.4045C116.849 92.5116 116.994 92.5718 117.146 92.5718C117.297 92.5718 117.443 92.5116 117.55 92.4045C117.657 92.2973 117.717 92.152 117.717 92.0004V86.8576C117.717 86.706 117.657 86.5607 117.55 86.4535C117.443 86.3463 117.297 86.2861 117.146 86.2861Z",
    fill: "#044D6E",
    stroke: "#044D6E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUserModalImage);
export default __webpack_public_path__ + "static/media/delete-user-modal-image.286c6b534b2f17926075d3129d7ebd82.svg";
export { ForwardRef as ReactComponent };